/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbApprenantRepresentantGridDto } from './FcbApprenantRepresentantGridDto';
import {
    FcbApprenantRepresentantGridDtoFromJSON,
    FcbApprenantRepresentantGridDtoFromJSONTyped,
    FcbApprenantRepresentantGridDtoToJSON,
} from './FcbApprenantRepresentantGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbApprenantRepresentantGridDtoPaginatedResults
 */
export interface FcbApprenantRepresentantGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbApprenantRepresentantGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbApprenantRepresentantGridDto>}
     * @memberof FcbApprenantRepresentantGridDtoPaginatedResults
     */
    results?: Array<FcbApprenantRepresentantGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbApprenantRepresentantGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbApprenantRepresentantGridDtoPaginatedResults interface.
 */
export function instanceOfFcbApprenantRepresentantGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbApprenantRepresentantGridDtoPaginatedResultsFromJSON(json: any): FcbApprenantRepresentantGridDtoPaginatedResults {
    return FcbApprenantRepresentantGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbApprenantRepresentantGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbApprenantRepresentantGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbApprenantRepresentantGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbApprenantRepresentantGridDtoPaginatedResultsToJSON(value?: FcbApprenantRepresentantGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbApprenantRepresentantGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

